
const { log } = console
const uuid = require('./utils/uuid.js')
const {
  fetchSceneMetadata,
  fetchSceneSb3
} = require('./utils/fetch-and-parse.js')

module.exports = function store (state, emitter) {
  emitter.on('next-level', () => {
    log('next-level')
    const gameStage = state.vm.runtime.getTargetForStage()
    let levelNumber = gameStage.lookupOrCreateVariable(uuid(), 'level #').value
    levelNumber = parseInt(levelNumber)
    if (isNaN(levelNumber)) {
      levelNumber = 1
    }
    levelNumber = Math.max(levelNumber, 1)
    emitter.emit('load-level', levelNumber + 1)
  })

  emitter.on('load-level', levelNumber => {
    log('load-level', levelNumber)
    let sceneId = null
    const gameStage = state.vm.runtime.getTargetForStage()
    if (state.projectMetadata.levels) {
      const levelLength = state.projectMetadata.levels.length
      let levelIndex = levelNumber - 1
      if (levelIndex > levelLength - 1) {
        levelIndex = (levelNumber % levelLength) - 1
        if (levelIndex < 0) {
          levelIndex = levelLength - 1
        }
      }
      sceneId = state.projectMetadata.levels[levelIndex]
    }
    const levelNumberVariable = gameStage.lookupOrCreateVariable(
      uuid(),
      'level #'
    )
    levelNumberVariable.value = levelNumber
    if (sceneId) {
      const fetchPromises = []
      fetchPromises.push(fetchSceneSb3(sceneId, state.projectMetadata))
      fetchPromises.push(fetchSceneMetadata(sceneId, state.projectMetadata))
      Promise.all(fetchPromises).then(results => {
        [ state.sceneData, state.sceneMetadata ] = results
        emitter.emit('load-scene')
      })
    } else {
      emitter.emit('load-scene')
    }
  })
}
